import { I as Icon, _ as __assign } from './loadable.esm-8884282c.js';
import React from 'react';
import 'styled-components';

var YoutubeIcon = function (props) { return (React.createElement(Icon, __assign({}, props, { viewBox: "0 0 26 26" }),
    React.createElement("path", { d: "M22.8 9c-.2-1.6-1-2.8-2.8-3-2.8-.5-7-.5-7-.5s-4.2 0-7 .5c-1.8.2-2.6 1.4-2.8 3-.2 1.6-.2 4-.2 4s0 2.4.2 4 1 2.8 2.8 3c2.8.5 7 .5 7 .5s4.2 0 7-.5c1.8-.4 2.5-1.4 2.8-3s.2-4 .2-4 0-2.4-.2-4zm-12.3 7.8V9.2l6.2 3.8-6.2 3.8z" }))); };

export { YoutubeIcon as default };
